import React, { ReactElement, ReactNode } from 'react';

import styles from './styles.module.scss';

import { InfoCircle, Loader, TableDataNotFound } from 'components/index';
import { FormatUtils } from 'utils';
import { IOVIYearByYear } from '../../../../../../../../types/interfaces';
import { TableProBlur } from '../../../OrganizationTreasury/components/DaoAssetsTable/components/TableProBlur';
import { TRENDS_TAB, TRENDS_TAB_DESCRIPTIONS } from 'constants/descriptions';

interface IYearByYearTableProps {
    title: string;
    lastUpdate?: string | null;
    infoText?: string;
    tableRowsData: IOVIYearByYear[];
    loading?: boolean;
    error?: string | null;
    headContent?: ReactNode;
    showBlur?: boolean;
}

const mockData = [
    { year: 2002, numberOfVotes: 4222 },
    { year: 2003, numberOfVotes: 3845 },
    { year: 2004, numberOfVotes: 5123 },
    { year: 2005, numberOfVotes: 4678 },
    { year: 2006, numberOfVotes: 3987 },
    { year: 2007, numberOfVotes: 5432 },
    { year: 2008, numberOfVotes: 4891 },
    { year: 2009, numberOfVotes: 5764 },
];
export const YearByYearTable = ({
    title,
    lastUpdate,
    infoText,
    tableRowsData,
    loading,
    headContent,
    showBlur,
}: IYearByYearTableProps): ReactElement => {
    const dataToRender = showBlur ? mockData : tableRowsData;
    const columnSize = `${100 / dataToRender?.length + 1}%`;

    return (
        <div className={styles.content}>
            <div className={styles.headSection}>
                <div className={styles.textSection}>
                    <h4>{title}</h4>
                    <InfoCircle tooltipText={infoText} className={styles.infoIcon} />
                    {lastUpdate && <h5>Last Update: {FormatUtils.getFormattedDate(lastUpdate)}</h5>}
                </div>
                {headContent}
            </div>

            <div className={styles.tableWrapper}>
                {dataToRender && dataToRender.length > 0 && (
                    <div className={`${styles.tableContainer} ${showBlur && styles.blurTableContainer}`}>
                        <div className={styles.tableHeader}>
                            <div key={'Year'} style={{ width: columnSize }}>
                                <div>
                                    <span className={styles.header}>{'Year'}</span>
                                </div>
                            </div>
                            {dataToRender.map((trd) => (
                                <div key={trd.year} style={{ width: columnSize }}>
                                    <div>
                                        <span className={styles.data}>{trd.year}</span>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className={styles.tableHeader}>
                            <div key={'Voters'} style={{ width: columnSize }}>
                                <div>
                                    <span className={styles.header}>{'Voters'}</span>
                                </div>
                            </div>
                            {dataToRender.map((trd) => (
                                <div key={trd.year} style={{ width: columnSize }}>
                                    <div>
                                        <span className={styles.data}>
                                            {FormatUtils.formatNumberWithCommas(trd.numberOfVotes, 0)}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {showBlur && (
                            <TableProBlur
                                title="Year by Year Voters is a DeepDAO Pro feature"
                                description={TRENDS_TAB_DESCRIPTIONS[TRENDS_TAB.YEAR_BY_YEAR]}
                            />
                        )}
                    </div>
                )}

                {loading && tableRowsData.length === 0 && (
                    <div className={styles.tableContainer}>
                        <Loader size={40} className={styles.loaderBox} />
                    </div>
                )}
                {tableRowsData.length === 0 && !loading && !showBlur && (
                    <TableDataNotFound forTable overflowMarginsSecondVariant />
                )}
            </div>
        </div>
    );
};
